import store from './store'
import router, {
  createRouter,
  constantRouterMap
} from '@/router'
import {
  hasValidAccessToken
} from '@/utils/refreshService'
const whiteList = ['/login', '/auth-redirect', '/login/forgetPassword','/mini-concern']

router.beforeEach((to, from, next) => {
  if (hasValidAccessToken()) {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      if (store.getters.user) {
        next()
      } else { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          if (res&&res.result) {
            store.dispatch('GenerateRoutes',
              res.result
            ).then(() => { // 根据用户权限生成可访问的路由表
              router.matcher = createRouter(constantRouterMap).matcher // 二次登陆去重
              router.addRoutes(store.getters.addRouters)
              next({
                ...to,
                replace: true
              })
            })
          }
        })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})